export default {
  'zh-CN': {
    help:{
      help:'帮助中心',
      BusinessInquiries:'业务咨询',
      UserManual:'新手教程',
      FAQ:'常见问题',
      //  帮助中心a
      OnlineE:'在线业务咨询-邮件服务',
      OnlineC:'在线业务咨询-在线客服咨询',
      OnlineEmail:'邮件咨询服务，您可以点击，并将您咨询的问题告诉我们',
      Click:'点击咨询',
      SPKClick:'SpeedPAK点击咨询',
      MCClick:'Multi-Channel点击咨询',
      OnlineMessage:'在线客服咨询服务，您可以点击，并将您咨询的问题告诉我们',
      //  帮助中心b
      speedManual:'卖家用户手册',
      SPKUserManual:'点击按钮查看中国大陆SpeedPAK卖家用户手册',
      SPKUserManualHk:'点击按钮查看中国香港SpeedPAK卖家用户手册',
      MCUserManual:'点击按钮查看Multi-Channel卖家用户手册',
      Registration:'用户注册&账户基本设置',
      Account:'用户认证',
      Deposit:'用户充值',
      OrderProcessing:'订单处理',
      ShipmentMethod:'物流查询',
      Preset:'SKU 预设',
      Shipment:'发货明细及费用',
      ClickPdf:'点击按钮查看PDF',
      //  帮助中心c
      Question01:'什么是橙联股份有限公司？',
      Answer01:'橙联股份是一家提供跨境电商整体解决方案的优质物流服务供应商,集物流，市场资源整合，信息系统研发应用和大数据分析等服务功能于一体的平台化公司。作为eBay联合物流战略的合作伙伴，拥有成熟先进的信息技术和丰富扎实的行业经验，为ebay卖家提供及时，可靠和透明的服务，从而提升买家体验。',
      Question02:'SpeedPAK是什么？是怎样的服务？是什么类型的服务？',
      Answer02:'SpeedPAK是eBay联合物流战略合作伙伴橙联股份有限公司共同打造，以eBay平台物流政策为基础，为eBay大中华区跨境出口电商卖家量身定制的美国、英国、德国、意大利、法国、西班牙、澳大利亚、加拿大及其他欧洲41国路向国际派送解决方案。',
      Question03:'SpeedPAK standard service是哪一类型的物流服务？',
      Answer03:'SpeedPAK将提供三种不同层次的服务，即：加快型服务，标准型服务，经济型服务。带有全程追踪的加快型服务平均物流时效为5-9个工作日，标准型服务平均物流时效为8-12个工作日，端到端全程带追踪。已上线的物流服务为SpeedPAK标准型服务及经济型服务。',
      Question04:'SpeedPAK standard service服务，物流时效多久？',
      Answer04:'平均物流时效为8-12个工作日，标准型服务将提供端到端全程物流追踪，经济型服务无国际段跟踪信息。',
      Question05:'该服务的优势是什么？',
      Answer51:'使用SpeedPAK服务派送的交易将被视为物流合规交易',
      Answer52:'政策支持：SpeedPAK以eBay平台政策为基础，推出高度契合eBay平台政策的物流服务。',
      Answer53:'服务稳定：大数据智能监控物流服务质量，建立预警机制，保障全年服务稳定。',
      Answer54:'透明跟踪：eDIS平台提供全程物流轨迹，自动同步至eBay主站，买卖双方可实时掌握货物运输进度。'
    }
  },
  'en-US':{
    help:{
      help:'Help Center',
      BusinessInquiries:'Business Inquiries',
      UserManual:'User Manual',
      FAQ:'FAQ',
    //  帮助中心a
      OnlineE:'Online customer service- e-mail inquiries',
      OnlineEmail:'Online customer service- e-mail inquiries, Click to send email',
      OnlineC:'Online customer service- messaging',
      Click:'Click to send',
      SPKClick:'Click to send SpeedPAK',
      MCClick:'Click to send Multi-Channel',
      OnlineMessage:'Online customer service- messaging, Click to send messages',
    //  帮助中心b
      speedManual:'SpeedPAK ebay user manual',
      SPKUserManual:'Click to view SpeedPAK(CN) PDF document',
      SPKUserManualHk:'Click to view SpeedPAK(HK) PDF document',
      MCUserManual:'Click to view Multi-Channel PDF document',
      Registration:'Registration & Account Setting',
      Account:'Account Authentication',
      Deposit:'Deposit',
      OrderProcessing:'Order Processing',
      ShipmentMethod:'Shipment Method',
      Preset:'Preset SKU',
      Shipment:'Shipment Details and Costs',
      ClickPdf:'Click to view PDF document',
    //  帮助中心c
      Question01:'What is Orange Connex(China) Limited?',
      Answer01:'Orange Connex(China) Limited is a technology company that is dedicated service global e-commerce industry. Through market analysis, system development, and resource integration, we provide services in logistic, finance, and big data aspects of global e-commerce industry.Orange Connex(China) Limited is a joint venture between J-Star, and the a pioneer of global e-commerce platform, eBay. Hence supporting our cause with tremendous amount of resources and years of successful experience within the industry. With our enriched background and strong foundation, our product is aimed to redefine our users’ experiences though Speed, Stability, Transparency, Cost Optimization, and Sustainability.',
      Question02:'What is SpeedPAK? What does the service do? What type of service is it?',
      Answer02:'SpeedPAK service is brought to you by ebay and ebay’s strategic partner, Orange Connex(China) Limited,. SpeedPAK is developed on the foundation of ebay’s platform policy, then customized to provide direct mail service to e-commerce businesses in the great China region. SpeedPAK’s service destinations include USA, UK, Germany, Italy, France, Spain, Australia, Canada, and 41 other European countries.',
      Question03:'What type of service is SpeedPAK Standard service?',
      Answer03:'SpeedPAK will offer 3 types of services, which are: Express, Standard, and Economy. Express service offers the average delivery time of 5-9 business days with end-to-end tracking information. Standard service offers the average delivery time of 8-12 business days with end-to-end tracking information. Standard and Economy services are currently available.',
      Question04:'What is the delivery time for SpeedPAK Standard service?',
      Answer04:'The average delivery time for SpeedPAK Standard service is 8-12 business days with complete and transparent tracking record(half way tracking information is available for SpeedPAK Economy service).',
      Question05:'What are the advantages of SpeedPAK services？',
      Answer51:'SpeedPAK services are recognized as approved services by ebay platform.',
      Answer52:'Platform Policy: SpeedPAK service is brought to you by ebay and Orange Connex(China) Limited,. Developed on the foundation of ebay’s platform policy, then customized to provide direct mail service to e-commerce businesses in the great China region.',
      Answer53:'Stable Services: Monitored by big data analysis, the alert system has ensured us with service stability throughout a year.',
      Answer54:'Clear Tracking: eDIS system provides tracking information that are synchronized with ebay platform in real time, hence providing transparent tracking information for our customers.'

    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/Help_local.js